import { render, staticRenderFns } from "./TedsLogo.vue?vue&type=template&id=4998f71e&"
import script from "./TedsLogo.vue?vue&type=script&lang=ts&"
export * from "./TedsLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports